import React from "react"

import font from "../../fonts/fonts.module.scss"
import styled from "styled-components"
import { device } from "../device"
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import { useTranslation } from 'gatsby-plugin-react-i18next'

import logo from "../../images/logos/lua_logo.svg"
import logoAzul from "../../images/logos/azul_logo.svg"
import mapa from "../../images/sobre/regioes.svg"
import mapaAzul from "../../images/sobre/regioes-azul-portugal.svg"
import mapaMobile from "../../images/sobre/regioes-mobile.svg"

const Regioes = ({ json, azulPortugal }) => {
  const {t} = useTranslation([json])
  const breakpoints = useBreakpoint()

  return(
    <StyledRegioes>
      <div className="logoTxt">
          <img src={azulPortugal ? logoAzul : logo} alt="Logo" className="logo"/>
          {breakpoints.mobile && 
            <div className={font.aGGBO + ' places'}>
              {azulPortugal ? 
                <>
                  <p className='p'>Península Setúbal</p>
                  <p className='p'>Palmela</p>
                  <p className='p'>Tejo</p>
                  <p className='p'>Alentejo</p>
                  <p className='p'>Dão</p>
                  <p className='p'>Porto</p>
                  <p className='p'>Douro</p>
                  <p className='p'>Vinho Verde</p>
                </>
              :
                <>
                  <p className='p'>Alentejo</p>
                  <p className='p'>Dão</p>
                  <p className='p'>Monção e Melgaço</p>
                  <p className='p'>Vinho Verde</p>
                  <p className='p'>Douro</p>
                </>
              }
            </div>
          }
          <h2 className={font.nSR + " regTxt"}>{t('regioes.text')}</h2>
      </div>
      {!breakpoints.mobile &&
        <img src={azulPortugal ? mapaAzul : mapa} alt="cenas" className="regMapa"/>
      }
      {breakpoints.mobile &&
        <img src={mapaMobile} alt="cenas" className="regMapaMobile"/>
      }

  </StyledRegioes>
  )
}

export default Regioes

const StyledRegioes = styled.div`
    position: relative;
    background: black;
    min-height: calc(100vh - 50px);

    @media ${device.desktop}{
      margin: 6vw 0;
      margin-left: 200px;
      padding: 8vw 0 8vw 2vw;
      min-height:unset;
    }

    @media ${device.desktopL}{
      margin-left: 15.65%;
    }

    .logoTxt{
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      text-align: center;
      padding: 30px 0;
      max-width: 700px;
      margin: 0 auto;

      @media ${device.desktop}{
        max-width: unset;
        margin: unset;
        min-height: unset;
        justify-items: center;
        justify-content: unset;
        padding: unset;
        width: 790px;
      }

      .places{
        color:#fff;
        z-index:1;
        margin: 30px 0;

        p{
          font-size: 18px;
          margin: 5px 0;
        }
      }

      .regTxt{
        color: #fff8f4;
        font-size:23px;
        z-index:1;
        padding:0 25px;
        margin: 30px 0;

        @media ${device.desktop}{
          font-size:30px;
          margin:unset;
          margin-top: 7vw;
          padding: unset;
          max-width: 475px;
        }
      }

      .logo{
        width:50%;
        z-index:1;
        margin: 30px 0;

        @media ${device.desktop}{
          width:30%;
          margin: unset;
        }

        @media ${device.desktopXL}{
          width:40%;
        }
      }
    }

    .regMapa{
      position: absolute;
      right: 6vw;
      bottom: -5.2vw;
      width: 35vw;
    }
    
    .regMapaMobile{
      position: absolute;
      height: 100%;
      width: 200%;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }
`
